/* eslint 'no-redeclare': 'off', eqeqeq: 'off'  */


import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../../Assets/styles/DraggableList.css';
import {MdDragHandle, MdAdd} from 'react-icons/md';
import {IoIosCloseCircle as IoCloseCircle} from 'react-icons/io';
import {Icon} from 'semantic-ui-react';

var placeholder = document.createElement("li");
placeholder.className = "placeholder";
const ErrorMsgStyle = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'font-size': '13px',
    'padding-top': '4px'
}
class DraggableList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            colors: ['Red', 'Green', 'Blue', 'Yellow', 'Black', 'White', 'Orange'],
            value: this.props.options,
            actualdata: this.props.options,
            hover: false,
            currentElementID: '',
            edit: false,
            data:{
                Field:'',
                FieldLabel: '',
                FieldId: this.props.id,
                Value: [],
                Display: true,
                DisplayOnWOForm: false,
                Required: '',
                selectedForSort:''
            },
            deletedList:[],
            ErrorDisplay: "none",
            EditedValue: ""
		}
        this.dragOver = this.dragOver.bind(this);
        this.dragStart = this.dragStart.bind(this);
        this.dragEnd = this.dragEnd.bind(this);
        this.hoverOn = this.hoverOn.bind(this);
        this.hoverOff = this.hoverOff.bind(this);
        this.editOptions = this.editOptions.bind(this);
        this.OptionChanged = this.OptionChanged.bind(this);
        this.AddValues = this.AddValues.bind(this);
        this.dragEnter = this.dragEnter.bind(this);
    }

    dragStart(e) {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        //e.dataTransfer.setData('text/html', this.dragged);
        e.dataTransfer.setData('Text',  e.currentTarget.id);
    }

    dragEnd(e) {
        this.dragged.style.display = 'block';
        if(this.dragged.parentNode.contains(placeholder)){
            var parent = placeholder.parentElement;   
            parent.removeChild(placeholder); 
        }else{
           //this.dragged.parentElement.parentElement.children[2].remove();
        }

        // update state
        var added_options = [];
        var EditedData = this.state.actualdata;
        var data = EditedData.value;
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over.dataset.id);
        to = (to == 0 ) ? 0 : to || data.length;
        if (from < to) to--;
        data.splice(to, 0, data.splice(from, 1)[0]);

        //Tracking Updated Rows
        var i = 0;
        data.forEach(el => {
                if(el.orderId != i)
                {
                    var iteration
                    if(this.props.id > 0 && this.props.fromWorkOrder == true && this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.1.Text'] && el.key == 6){
                        el.orderId = 999;
                        iteration = 999;
                    }
                    else if(this.props.id > 0 && this.props.fromWorkOrder == false && this.props.getLabels['PreventativeMaintenance.Options.' + this.props.id + '.Text'] == this.props.getLabels['PreventativeMaintenance.Options.1.Text'] && el.key == 6)
                    {
                        el.orderId = 999;
                        iteration = 999;
                    }
                    else{
                    el.orderId = i;
                    iteration = i;
                    }
                    added_options = this.AddToSaveList(iteration, el);
                }
                i++;
            });
        var Ordering = this.props.SortOptions;
        Ordering(EditedData, added_options);

        EditedData.value = data;
        this.setState({ actualdata: EditedData, data: added_options });
    }

    dragOver(e) {

        e.stopPropagation();
        e.preventDefault();
        this.dragged.style.display = "none";
        if (e.target.className === 'placeholder') return;
        this.over = e.target;
        e.target.parentNode.insertBefore(placeholder, e.target);
    }

    dragEnter(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    hoverOn(e) {
        this.setState({ hover: true, currentElementID: e.target.dataset.id });
    }

    hoverOff() {
        this.setState({ hover: false, currentElementID: '',edit: false });
    }

    editOptions(e)
    {
        var EditValue = this.state.currentElementID != '' ? this.state.actualdata.value[this.state.currentElementID].value : '';
        this.setState({hover: false, edit: true, EditedValue: EditValue})
    }

    OptionChanged(id, isCustom, index, element, e) {
        this.setState({ EditedValue : e.target.value });        
    }

    AfterOptionChanged(id, isCustom, index, element, e){
        var added_options = this.state.data;
        var saving_data = this.state.actualdata;
        var EnteredValue = this.state.EditedValue;
        if (saving_data.value !== "--" && EnteredValue.trim() != "") {
            //Duplicate Value Validation
            var lstValues = saving_data.value.filter(x => x.value.toUpperCase().trim() === EnteredValue.toUpperCase().trim() && x.index !== index);
            var IsDuplicate = (lstValues !== null && lstValues.length > 0) ? true : false;
            if(!IsDuplicate){
                saving_data.value.forEach(el => {
                    if(el.index == index)
                    {
                        el.value = this.state.EditedValue.trim();
                    }
                });
        
                if (added_options.Value.filter(x => x.index == index).length > 0) {
                    added_options.Value.forEach(element => {
                        if (element.index == index) {
                            element.value = this.state.EditedValue.trim();
                        }
                    });
                }
                else {
                    var lineitem = {
                        "key": id,
                        "value": this.state.EditedValue.trim(),
                        "isCustom": isCustom,
                        "index":index,
                        "orderId":element.orderId
                    }
                    added_options.Value.push(lineitem);
                }
        
                var Update = this.props.UpdateOptions;
                Update(added_options, saving_data);
        
                this.setState({
                    data: added_options,
                    actualdata: saving_data
                });
            }
        }
    }

    DeleteValue(index, id, e) {

        e.stopPropagation();
        var IsExists = false;

        if(this.props.fromWorkOrder == true)
        {
        if (this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.1.Text'] && id > 0) {
            if (this.props.getList.filter(x => x.status == id).length > 0) {
                IsExists = true;
            }
        }
        if (this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.3.Text'] && id > 0) {
            if (this.props.getList.filter(x => x.urgency == id).length > 0) {
                IsExists = true;
            }
        }
        if (this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.9.Text'] && id > 0) {
            if (this.props.getList.filter(x => x.workOrderDetail.problemID == id).length > 0) {
                IsExists = true;
            }
        }
    }
    else{
        if (this.props.getLabels['PreventativeMaintenance.Options.' + this.props.id + '.Text'] == this.props.getLabels['PreventativeMaintenance.Options.1.Text'] && id > 0) {
            if (this.props.getPMList.filter(x => x.status == id).length > 0) {
                IsExists = true;
            }
        }      
    }

        if (!IsExists) {
            var added_options = this.state.data;
            var saving_data_actual = this.state.actualdata;
            var deltedList = this.state.deletedList;
            var i = 0;

            if(id > 0)
            {
                deltedList.push(saving_data_actual.value.filter(x => x.index == index)[0]);
            }

            added_options.Value = added_options.Value.filter(x => x.index !== index);
            saving_data_actual.value = saving_data_actual.value.filter(x => x.index !== index);

            saving_data_actual.value.forEach(el => {
                el.orderId = i;
                i+=1;
            });

            var Delete = this.props.DeleteOptions;
            Delete(saving_data_actual,added_options,deltedList,IsExists);

            this.setState({ actualdata: saving_data_actual, data: added_options, deletedList: deltedList, edit: false});
        }
        else
        {
            var Delete = this.props.DeleteOptions;
            Delete('','','',IsExists);

            this.setState({warning:!this.state.warning, edit: true});
        }
    }

    AddValues() {
        var IsDuplicate = false;
        this.setState({ ErrorDisplay: "none" });
        if (this.refs.custom_value.value.trim() != "") {
            var EnteredValue = this.refs.custom_value.value;
            var saving_data_actual = this.state.data;
            var saving_data = this.state.actualdata;
            if(saving_data.value === "--")
                saving_data.value = [];
            else {
                //Duplicate Value Validation
                var lstValues = saving_data.value.filter(function (item) {
                    return EnteredValue.toUpperCase().trim() == item.value.toUpperCase().trim()
                });
                IsDuplicate = (lstValues !== null && lstValues.length > 0) ? true : false;
            }
            if (!IsDuplicate) {
                var lineitem = {
                    "key": 0,
                    "value": this.refs.custom_value.value.trim(),
                    "isCustom": true,
                    "index": saving_data.value.length,
                    "orderId": saving_data.value.length
                }
                saving_data.value.push(lineitem);
                saving_data_actual.Value.push(lineitem);

                this.refs.custom_value.value = "";

                var Add = this.props.AddOptions;
                Add(saving_data, saving_data_actual);

                this.setState({ actualdata: saving_data, data: saving_data_actual })
            }else {
                this.refs.custom_value.value = "";
                this.setState({ ErrorDisplay: "block" });
            }
        }
    }

    AddToSaveList = (order, row) =>
    {
        var added_options = this.state.data;
        if(added_options.Value !== undefined){
            if (added_options.Value.filter(x => x.index == row.index).length > 0) {
                added_options.Value.forEach(element => {
                    if (element.index == row.index) {
                        element.orderId = order;
                    }
                });
            }
            else {
                var lineitem = {
                    "key": row.key,
                    "value": row.value,
                    "isCustom": row.isCustom,
                    "index": row.index,
                    "orderId": order
                }
                added_options.Value.push(lineitem);
            }
        }
        return added_options;
    }

    render() {
        var listItems = "";
        var itemClosed = (this.props.id > 0 && this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.1.Text']) ? this.state.actualdata.value.filter(x => x.key == 6)[0] : "";
        if(this.state.actualdata.value !== "--")
        {
            listItems = this.state.actualdata.value.map((item, i) => (
            (this.props.id > 0 && this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.1.Text'] && item.key == 6) ? 
            ""
            : 
            <li className='liststyle'
                data-id={i}
                key={i}
                draggable= {(this.state.edit && this.state.currentElementID == i) ? 'false' : 'true'}
                onDragEnd={this.dragEnd}
                onDragStart={this.dragStart}
                onDragEnter={this.dragEnter}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
                onDragOver={this.dragOver}
                onClick={this.editOptions}
            >
            {(this.state.hover && this.state.currentElementID == i) ? <MdDragHandle /> : String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160)}&nbsp;{(this.state.edit && this.state.currentElementID == i) ? <input type='text' style={{border: "0px solid #000000", backgroundColor: '#cecece', width:"320px"}} value={this.state.EditedValue} onChange={(e) => this.OptionChanged(item.key,item.isCustom,item.index,item,e)} onMouseLeave={(e) => this.AfterOptionChanged(item.key,item.isCustom,item.index,item,e)} /> : item.value}&nbsp;{(this.state.hover && this.state.currentElementID == i) ? <IoCloseCircle style={{float:'right'}} onClick={(e) =>{this.DeleteValue(item.index,item.key,e)}} /> : ""}
            </li>           
            ));
        }
        return (     
            <ul className='ulstyle'>
                {listItems}
                {
                itemClosed != "" ?
                <li style={{border: '1px solid black', background:'#eee', padding: '5px 5px'}} onDragOver={this.dragOver}>
                {String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160)} {itemClosed.value}
                </li>
                : ""}
                <li style={{border: '1px solid black', padding: '5px 5px'}} onDragOver={this.dragOver}> 
                    <table style={{width: '100%', backgroundColor: '#fff'}}>
                    <tr>
                        <td><MdAdd onClick={this.AddValues} /></td>
                        <td>
                            <input type='text' ref='custom_value' placeholder='List Item' style={{border: "0px solid #000000", backgroundColor: '#fff', width:"320px"}}/>
                            <p style={{ "display": this.state.ErrorDisplay, "margin-right": "-150px", "float": "right"}}>
                                <Icon name='exclamation triangle' style={{ "color": "#D42D27", "width": "22px", "height": "22px", "padding-top": "4px" }} />
                                <b style={ErrorMsgStyle}>Duplicate Value Entry</b>
                            </p>
                        </td>
                    </tr>
                </table>
                </li>
            </ul>
        );
    }
};

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getList: state.WorkorderRootReducer.WorkOrderList,
        getPMList: state.WorkorderRootReducer.PreventativeMaintenanceList
    };
};

export default connect(mapStateToProps, null)(DraggableList);